import { useEffect } from "react";
import { MODES, OBJECT_TYPES } from "../configuratorConstants";
import useMouseInteractions from './useMouseInteractions';
import useModifierKeys from './useModifierKeys';

const useCanvasInteractions = ({
    viewTransform,
    setViewTransform,
    svgRef,
    mainContainerRef,
    activeMode,
    setSelectedObjectId,
    screenToWorld,
    updateModulePosition,
    snapAndFinalizeModulePosition,
    onWallSegmentClick,
    elementTypeToPlace,
    onContextMenu,
    dispatch,
}) => {
    const modifierKeys = useModifierKeys(mainContainerRef, svgRef);

    const {
        isPanning,
        isDraggingModule,
        handleMouseDownOnCanvas,
        handleMouseMove,
        handleMouseUp,
        handleMouseLeave,
    } = useMouseInteractions({
        viewTransform,
        modifierKeys,
        mainContainerRef,
        svgRef,
        setViewTransform,
        activeMode,
        setSelectedObjectId,
        screenToWorld,
        updateModulePosition,
        snapAndFinalizeModulePosition,
        onWallSegmentClick,
        elementTypeToPlace,
        dispatch,
    });

    useEffect(() => {
        const svgElement = svgRef.current;
        if (!svgElement) return;

        const handleInteraction = (handler) => (e) => {
            // Блокуємо специфічні для модульного режиму дії
            if (activeMode === MODES.FRAMELESS) {
                // Дозволяємо панорамування середньою кнопкою або лівою, якщо інструмент не обрано
                // Также разрешаем обработку для размещения ролеты (клики по окнам)
                const isBlindsPlacement = elementTypeToPlace === OBJECT_TYPES.WINDOW_BLINDS;
                if (e.button === 1 || (e.button === 0 && (!elementTypeToPlace || isBlindsPlacement))) {
                    handler(e);
                }
                return;
            }
            // В модульному режимі все працює як раніше
            handler(e);
        };

        const mouseDownHandler = handleInteraction(handleMouseDownOnCanvas);
        const mouseMoveHandler = handleInteraction(handleMouseMove);
        const mouseUpHandler = handleInteraction(handleMouseUp);
        const mouseLeaveHandler = handleInteraction(handleMouseLeave);
        const contextMenuHandler = (e) => onContextMenu(e, null, "canvas");

        svgElement.addEventListener('mousedown', mouseDownHandler);
        window.addEventListener('mousemove', mouseMoveHandler);
        window.addEventListener('mouseup', mouseUpHandler);
        svgElement.addEventListener('mouseleave', mouseLeaveHandler);
        svgElement.addEventListener('contextmenu', contextMenuHandler);

        return () => {
            svgElement.removeEventListener('mousedown', mouseDownHandler);
            window.removeEventListener('mousemove', mouseMoveHandler);
            window.removeEventListener('mouseup', mouseUpHandler);
            svgElement.removeEventListener('mouseleave', mouseLeaveHandler);
            svgElement.removeEventListener('contextmenu', contextMenuHandler);
        };
    }, [
        svgRef, activeMode, handleMouseDownOnCanvas, handleMouseMove, handleMouseUp, handleMouseLeave,
        onContextMenu, elementTypeToPlace
    ]);

    return { isPanning, isDraggingModule };
};

export default useCanvasInteractions;